// @ts-nocheck
import { ReplaceKey } from 'helpers/ReplaceKey';
import notificationAPI from './api';
import TYPES from './types';

export const getNotifications = async (successCB, errorCB) => {
    const handleError = (error) => {
        if (errorCB && typeof errorCB === 'function') {
            errorCB(error);
        } else {
            throw new Error(`Error loading notifications: ${JSON.stringify(error)}`);
        }
    };

    try {
        const response = await notificationAPI.getNotifications();
        let data = response.data.data;

        if (data) {
            data = data.map((notif) => ReplaceKey(notif, '_id', 'id'));

            if (successCB && typeof successCB === 'function') {
                successCB(data);
            }

            return data;
        }
        handleError({ status: response.data.status, type: 'API_ERROR', msg: response?.message ?? response });
    } catch (error) {
        handleError({ type: 'API_ERROR', msg: error });
    }
};

export const refreshNotifications = (dispatch) => async (errContext, successCB, errorCB) => {
    const onNotificationsLoadError = ({ status, type, msg }) => {
        if (errContext && typeof errContext?.DISPATCH === 'function') {
            errContext.DISPATCH({
                type,
                payload: { status, alert: msg },
            });
            if (errorCB && typeof errorCB === 'function') {
                errorCB({ status, type, msg });
            }
        } else {
            throw new Error(`Error loading notifications: ${JSON.stringify({ status, type, msg })}`);
        }
    };

    const onNotificationsLoaded = (notifications) => {
        dispatch({
            type: TYPES.SET_NOTIFICATIONS,
            payload: notifications,
        });

        if (successCB && typeof successCB === 'function') {
            successCB(notifications);
        }
    };

    await getNotifications(onNotificationsLoaded, onNotificationsLoadError);
};

export const markNotificationAsRead = (dispatch) => async (notification, errContext) => {
    try {
        if (notification.messageId) {
            await notificationAPI.markNotificationAsReadByMessageId(notification.messageId);
            dispatch({ type: TYPES.UPDATE_NOTIFICATION, payload: { messageId: notification.messageId, read: true } });
        } else if (notification.id) {
            await notificationAPI.markNotificationAsRead(notification.id);
            dispatch({ type: TYPES.UPDATE_NOTIFICATION, payload: { id: notification.id, read: true } });
        } else {
            throw new Error('no id');
        }
    } catch (error) {
        if (errContext) {
            errContext.DISPATCH({ type: 'API_ERROR', payload: error });
        } else {
            throw new Error(`Error updating notification: ${JSON.stringify(error)}`);
        }
    }
};

export const addFCMNotification = (dispatch) => async (
    messageId,
    jobId,
    serviceId,
    title,
    timestamp,
) => {
    dispatch({
        type: TYPES.ADD_FCM_NOTIFICATION,
        payload: {
            messageId: messageId,
            jobId: jobId,
            serviceId: serviceId,
            title: title,
            timestamp: timestamp,
        },
    });
};
